import { Breadcrumb, type BreadcrumbItem } from '@/components/system';

type HelpBreadcrumbProps = {
    items: BreadcrumbItem[];
};

export function HelpBreadcrumb({ items }: HelpBreadcrumbProps) {
    return <Breadcrumb items={items} aria-label="Navegação da central de ajuda" />;
}
